import axios from 'axios';

const DEV_API = process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : '';
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || DEV_API || '').replace(/\/$/, '');
// En prod sur Vercel (1 projet), les fonctions sont sous /api sur le même domaine.
const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

/** Filtres alignés sur api/formations.js */
function filterFormationsList(list, params = {}) {
  const { category, type, search } = params;
  let out = [...list];
  if (category && category !== 'Toutes') out = out.filter((f) => f.category === category);
  if (type && type !== 'Toutes') out = out.filter((f) => f.type === type);
  if (search) {
    const q = String(search).toLowerCase();
    out = out.filter(
      (f) =>
        String(f.title || '').toLowerCase().includes(q)
        || String(f.code || '').toLowerCase().includes(q),
    );
  }
  return out;
}

let cachedCatalogPayload = null;

async function loadCatalogFromStatic() {
  if (cachedCatalogPayload) return cachedCatalogPayload;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const res = await fetch(`${base}/catalog.json`);
  if (!res.ok) throw new Error(`catalog.json: ${res.status}`);
  const payload = await res.json();
  cachedCatalogPayload = payload;
  return payload;
}

async function fetchFormationsFromApi(params) {
  const { data } = await api.get('/formations', { params });
  return data;
}

export const fetchFormations = async (params = {}) => {
  try {
    const data = await fetchFormationsFromApi(params);
    if (Array.isArray(data) && data.length > 0) return data;
  } catch {
    /* /api absent ou renvoie du HTML (hébergement statique seul) */
  }
  const blob = await loadCatalogFromStatic();
  const list = blob.formations || [];
  return filterFormationsList(list, params);
};

/** Détail par id (liste chargée une fois côté client). */
export const fetchFormationById = async (id) => {
  const list = await fetchFormations();
  const num = Number(id);
  return Array.isArray(list) ? list.find((f) => f.id === num) || null : null;
};

export const fetchPopularFormations = async () => {
  try {
    const { data } = await api.get('/formations/popular');
    if (Array.isArray(data) && data.length > 0) return data;
  } catch {
    /* idem fetchFormations */
  }
  const blob = await loadCatalogFromStatic();
  const list = blob.formations || [];
  return list.filter((f) => f.popular).slice(0, 8);
};

export const fetchTestimonials = async () => {
  try {
    const { data } = await api.get('/testimonials');
    if (Array.isArray(data) && data.length > 0) return data;
  } catch {
    /* pas de route /api sur certains déploiements */
  }
  const blob = await loadCatalogFromStatic();
  return blob.testimonials || [];
};

export const fetchBlog = async () => {
  try {
    const { data } = await api.get('/blog');
    if (Array.isArray(data) && data.length > 0) return data;
  } catch {
    /* idem */
  }
  const blob = await loadCatalogFromStatic();
  return blob.blogPosts || [];
};

export const submitContact = async (payload) => {
  const { data } = await api.post('/contact', payload);
  return data;
};

export const subscribeNewsletter = async (email, source = 'footer') => {
  const { data } = await api.post('/newsletter', { email, source });
  return data;
};

/** Demande d’inscription (rappel) : enregistrement + e-mail interne si Resend ou SMTP est configuré côté serveur. */
export const submitFormationLead = async (payload) => {
  const { data } = await api.post('/register', payload);
  return data;
};
